export const spacingTokens = [
  { name: 'auto', value: 'var(--auto)' },
  { name: 'space-0', value: 'var(--space-0, 0rem)' },
  { name: 'space-4', value: 'var(--space-4, 0.25rem)' },
  { name: 'space-8', value: 'var(--space-8, 0.5rem)' },
  { name: 'space-12', value: 'var(--space-12, 0.75rem)' },
  { name: 'space-16', value: 'var(--space-16, 1rem)' },
  { name: 'space-20', value: 'var(--space-20, 1.25rem)' },
  { name: 'space-24', value: 'var(--space-24, 1.5rem)' },
  { name: 'space-32', value: 'var(--space-32, 2rem)' },
  { name: 'space-40', value: 'var(--space-40, 2.5rem)' },
  { name: 'space-48', value: 'var(--space-48, 3rem)' },
  { name: 'space-64', value: 'var(--space-64, 4rem)' },
  { name: 'space-80', value: 'var(--space-80, 5rem)' },
  { name: 'space-96', value: 'var(--space-96, 6rem)' },
  { name: 'space-128', value: 'var(--space-128, 8rem)' },
  { name: 'space-160', value: 'var(--space-160, 10rem)' },
  { name: 'space-192', value: 'var(--space-192, 12rem)' },
  { name: 'space-224', value: 'var(--space-224, 14rem)' },
  { name: 'space-256', value: 'var(--space-256, 16rem)' },
  {
    name: 'space-sectionwithnav-phone',
    value: 'var(--space-section-phone, 135px)',
  },
  {
    name: 'space-sectionwithnav-tablet',
    value: 'var(--space-section-tablet, 183px)',
  },
  {
    name: 'space-sectionwithnav-desktop',
    value: 'var(--space-section-desktop, 215px)',
  },
];
